import Note from "components/Note/Note";
import React from "react";
import { paratext } from "styles";

interface IAccessInstantPayProps {
  setLastCompletedStep: (id: number) => void;
  qrUrl: string;
  businessUuid: string;
}

const AccessInstantPay: React.FC<IAccessInstantPayProps> = ({ qrUrl }) => {
  return (
    <div className="w-full border">
      <p className="bg-skyBlue p-3 bg-opacity-5 font-semibold text-xs">
        Download Your QR Code
      </p>
      <div className="p-3 flex gap-6 flex-col">
        <p className={`${paratext} !text-xs`}>
          Here's your business's Open Rewards QR code! Click "Download" to
          generate a printable file.
        </p>

        <div className="flex justify-center">
          <img width={200} height={200} src={qrUrl} />
        </div>
        <p className={`${paratext} !text-xs`}>
          Print your QR code and display it prominently in your store for easy
          customer access.
        </p>
        <Note note="Ensure that your QR code is visible and easy for customers to scan." />
      </div>
    </div>
  );
};

export default AccessInstantPay;
